import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const dayTypesApiRoutes = {
    list: apiDataManagerBaseURL + "daytypes",
    load: apiDataManagerBaseURL + "daytypes/",
    create: apiDataManagerBaseURL + "daytypes/",
    update: apiDataManagerBaseURL + "daytypes/",
    delete: apiDataManagerBaseURL + "daytypes/",
    setOrder: apiDataManagerBaseURL + "daytypes/",
};

export class DayTypeAPI {
    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? dayTypesApiRoutes.list : `${dayTypesApiRoutes.list}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        return API.authenticatedRequest({
            url: dayTypesApiRoutes.load + id,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(dayType) {
        return API.authenticatedRequest({
            url: dayTypesApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(dayType)
        });
    }

    static update(id, dayType) {
        return API.authenticatedRequest({
            url: dayTypesApiRoutes.update + id,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(dayType)
        });
    }

    static setOrder(dayTypes) {
        return API.authenticatedRequest({
            url: dayTypesApiRoutes.setOrder,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(dayTypes)
        });
    }

    static delete(id) {
        return API.authenticatedRequest({
            url: dayTypesApiRoutes.delete + id,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}